import collegeApplicationRoadmapBanner from '@backrs_ui/grow-ui/src/assets/images/college-application-roadmap/college-application-roadmap-banner.png';
import startSticker from '@backrs_ui/grow-ui/src/assets/images/college-application-roadmap/start-sticker.png';
import { GuidePageShell } from '@backrs_ui/grow-ui/src/components/GuidePage';

import { Box, SxProps, Theme } from '@mui/material';

import { useAgentContext } from './CollegeApplicationRoadmapGuidePageContainer.agentContext';
import {
  RoadmapFinalThoughts,
  RoadmapMonthDetail,
  RoadmapOverviewDetail,
  RoadmapTimeline,
  type RoadmapTimelineItem,
} from './components';
import { collegeApplicationRoadmapContent } from '../content';

const TIMELINE_ID_PREFIX = 'college-application-roadmap-timeline';

const COLLEGE_APPLICATION_ROADMAP_TOOL_ID = 'college_application_roadmap_guide';

const { header, heroCallout, timeline, finalThoughts, footer } = collegeApplicationRoadmapContent;

const TIMELINE_ITEMS: readonly RoadmapTimelineItem[] = [
  {
    id: 'overview',
    railLabel: timeline.overviewCard.railLabel,
    title: timeline.overviewCard.title,
    overview: timeline.overviewCard.overview,
    stickerSrc: startSticker,
    detail: <RoadmapOverviewDetail header={header} callout={heroCallout} />,
  },
  ...timeline.months.map((month) => ({
    id: month.id,
    railLabel: month.period.label,
    title: month.title,
    overview: month.overview,
    badge: month.badge,
    detail: (
      <RoadmapMonthDetail
        month={month}
        focusTitle={timeline.focusTitle}
        toolsTitle={timeline.toolsTitle}
      />
    ),
  })),
  {
    id: 'final-thoughts',
    railLabel: timeline.finalThoughtsCard.railLabel,
    title: timeline.finalThoughtsCard.title,
    overview: timeline.finalThoughtsCard.overview,
    detail: <RoadmapFinalThoughts finalThoughts={finalThoughts} footer={footer} />,
  },
];

export const CollegeApplicationRoadmapGuidePageContainer = () => {
  useAgentContext();

  return (
    <GuidePageShell
      toolId={COLLEGE_APPLICATION_ROADMAP_TOOL_ID}
      banner={{ src: collegeApplicationRoadmapBanner, alt: header.title }}
    >
      <Box sx={bodySx}>
        <RoadmapTimeline idPrefix={TIMELINE_ID_PREFIX} items={TIMELINE_ITEMS} />
      </Box>
    </GuidePageShell>
  );
};

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  pt: backrs.spacing['spacing-3xl'],
});
